import * as React from "react";
import { IconBase, IIconBase } from "./IconBase";

export const CheckboxCheckIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props} viewBox="0 0 48 48">
    <title>CheckboxCheck</title>
    <polygon points="17.1768034 28.0834512 40.2602546 5 48 12.7397454 17.3125884 43.427157 0 26.1824611 7.7397454 18.4427157"></polygon>
  </IconBase>
);
